module.exports = __webpack_public_path__ + "img/thumbnail_RedRuffedLemur_m_normal.a1154d5d.png";